let name = 'productnaam';
let ean = '8719632983484';
let company = 'Bedrijfsnaam';

let labelType = '30323';

function labelXml() {
	if (labelType === '30323') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30323();
	} else if (labelType === '30321') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30321();
	}
}

function Dymo30323() {
	let dymo30323 = null;
	try {
		dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/product/30323.xml');
	} catch (error) {
		dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/product/30323.xml');
	}

	return dymo30323;
}

function Dymo30321() {
	let Dymo30321 = null;
	try {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/product/30321.xml');
	} catch (error) {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/product/30321.xml');
	}

	return Dymo30321;
}

function createLabel() {
	const label = labelXml();

	label.setObjectText('name', name);
	label.setObjectText('ean', ean);
	label.setObjectText('bottomText', company);

	return label;
}

export default {
	setName(newName) {
		name = newName;
	},
	setEan(newEan) {
		ean = newEan;
	},
	setCompany(newCompany) {
		company = newCompany;
	},
	setLabelType(newLabelType) {
		labelType = newLabelType;
	},
	getLabel: createLabel,
}
